let initialState = {
  ppt_response: null,
  ppt_img_url: null,
  image_list: [],
  isPPTModalOpen: false,
  pptViewGenerating: false,
  ppt_template_data: null,
  aiInsights: null,
  aiInsightsLoader: false,
  pptGenerateStatus: false,
  ppt_offset: 0,
  call_ppt: false,
  downloadPPT: false,
  mapRendered: false,
  aiInsightsStatus: null,
  deeperAIInsightLoader: { insight_type: null, loader: false },
  aiDeeperInsightsStatus: {
    peak: { data: null, level_1: null, level_2: null },
    valley: { data: null, level_1: null, level_2: null },
    top_key: { level_1: null, level_2: null },
  },
  ppt_id: null,
};

const PPT = (state = initialState, action) => {
  switch (action.type) {
    case "SET_PPT_RESPONSE":
      return {
        ...state,
        ppt_response: action.payload,
      };
    case "SET_PPT_MODAL_OPEN":
      return {
        ...state,
        isPPTModalOpen: action.payload,
      };
    case "SET_PPT_GENERATE_STATUS":
      return {
        ...state,
        pptGenerateStatus: action.payload,
      };
    case "SET_PPT_TEMPLATE_DATA":
      return {
        ...state,
        ppt_template_data: action.payload,
      };
    case "SET_PPT_IMAGE_URL":
      return {
        ...state,
        ppt_img_url: action.payload,
      };
    case "SET_PPT_ON_GENERATING_MODE":
      return {
        ...state,
        pptViewGenerating: action.payload,
      };
    case "SET_IMAGE_LIST":
      return {
        ...state,
        image_list: action.payload,
      };
    case "SET_PPT_ID":
      return {
        ...state,
        ppt_id: action.payload,
      };
    case "SET_AI_GENERATED_INSIGHTS":
      return {
        ...state,
        aiInsights: action.payload,
      };
    case "SET_AI_INSIGHT_LOADER":
      return {
        ...state,
        aiInsightsLoader: action.payload,
      };
    case "SET_PPT_LOADER_OFFSET":
      return {
        ...state,
        ppt_offset: action.payload,
      };
    case "SET_CALL_PPT":
      return {
        ...state,
        call_ppt: action.payload,
      };
    case "SET_PPT_DOWNLOAD":
      return {
        ...state,
        downloadPPT: action.payload,
      };
    case "SET_MAP_RENDERED":
      return {
        ...state,
        mapRendered: action.payload,
      };
    case "SET_AI_INSIGHTS_STATUS":
      return {
        ...state,
        aiInsightsStatus: action.payload,
      };
    case "SET_DEEPER_AI_INSIGHTS_STATUS":
      return {
        ...state,
        aiDeeperInsightsStatus: action.payload,
      };
    case "SET_DEEPER_AI_INSIGHTS_LOADER":
      return {
        ...state,
        deeperAIInsightLoader: action.payload,
      };
    default:
      return state;
  }
};

export default PPT;
